// The sales popup inserts an empty javascript: link before it has a product.
// Keep that placeholder inert; the app assigns the real product URL when ready.
(function () {
  function repair(anchor) {
    if (!anchor.matches('a.bcsell-atc-product')) return;
    if (/^javascript:/i.test(anchor.getAttribute('href') || '')) {
      anchor.dataset.tsPlaceholderRel = anchor.getAttribute('rel') || '';
      anchor.removeAttribute('href');
      anchor.removeAttribute('rel');
    } else if (anchor.hasAttribute('href') && 'tsPlaceholderRel' in anchor.dataset) {
      if (anchor.dataset.tsPlaceholderRel) anchor.setAttribute('rel', anchor.dataset.tsPlaceholderRel);
      delete anchor.dataset.tsPlaceholderRel;
    }
  }
  function inspect(node) {
    if (node.nodeType !== 1) return;
    repair(node);
    node.querySelectorAll('a.bcsell-atc-product').forEach(repair);
  }
  inspect(document.body);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(inspect);
    });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();
